<template>
  <ion-page>
    <ion-progress-bar
      :value="Math.random(0, 1)"
      v-show="$store.state.hide"
    ></ion-progress-bar>
    <ion-content>
      <div class="wrapper">
        <div class="inner-row">
          <div class="logo">
            <img src="assets/logo/logo.png" alt="" />
          </div>
        </div>
        <div class="wrapper-content">
          <div class="form-wrapper">
            <div
              class="form-title"
              style="width: 90%; margin-left: auto; margin-right: auto"
            >
              <h1>Create an Account</h1>
              <div class="auxiliary">
                <div class="small-line"></div>
                <h3>Sign up with</h3>
              </div>
              <div class="account-btns">
                <a>
                  <img src="assets/images/google.png" alt="" />
                  <p>Google</p>
                </a>
                <a>
                  <img src="assets/images/facebook.png" alt="" />
                  <p>Facebook</p>
                </a>
              </div>
            </div>
            <div class="form-container">
              <div class="form-row">
                <div class="form-column">
                  <label for="name">Name</label>
                  <input
                    type="text"
                    class="input-control"
                    placeholder="Full name"
                    name="name"
                    required
                    autocomplete="off"
                    v-model="user.name"
                  />
                </div>
                <div class="form-column">
                  <label for="username">Username</label>
                  <input
                    type="text"
                    class="input-control"
                    placeholder="Username"
                    name="username"
                    required
                    autocomplete="off"
                    v-model="user.username"
                  />
                </div>
              </div>
              <div class="form-column" style="margin-bottom: 20px">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="input-control"
                  name="email"
                  placeholder="Email address"
                  required
                  autocomplete="off"
                  v-model="user.email"
                />
              </div>
              <div class="form-pass">
                <label for="password">Password</label>
                <input
                  type="password"
                  class="input-control"
                  name="password"
                  placeholder="Password"
                  required
                  autocomplete="off"
                  v-model="user.password"
                />
              </div>
              <div class="form-checkbox">
                <input
                  type="checkbox"
                  name="terms"
                  class="agreement"
                  required
                />
                <p>
                  I agree with
                  <router-link to="/legal_terms_of_service_and_agreement"
                    >Terms of Service</router-link
                  >
                  and our
                  <router-link to="/legal_terms_of_service_and_agreement"
                    >Privacy Policy.</router-link
                  >
                </p>
              </div>
              <div class="form-submit">
                <button type="button" name="submit" @click.prevent="register">
                  Sign up
                </button>
              </div>
            </div>
            <div class="addition">
              <p>
                Already have an account?
                <router-link to="/login">Sign in</router-link>
              </p>
            </div>
          </div>
          <div class="svg-wrapper">
            <img src="assets/images/social.svg" alt="" />
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent } from "@ionic/vue";
export default {
  components: {
    IonPage,
    IonContent,
  },
  mounted() {},
  data() {
    return {
      user: {
        username: "",
        name: "",
        email: "",
        password: "",
      },
      username: "",
      name: "",
      email: "",
      provider: "",
      provider_id: "",
      password: "",
    };
  },
  methods: {
    register() {
      let user = {
        first_name: this.user.name,
        username: this.user.username,
        email: this.user.email,
        password: this.user.password,
        role_id: 1,
        isVerified: 0,
      };
      this.$store.dispatch("registerAccount", user);
      this.$store.state.hide = true;
      // setTimeout(() => {
      //   this.$router.go("/home");
      // }, 3000);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@500;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: "Quicksand", sans-serif;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  width: 100%;
  height: 100%;
}
.inner-row {
  width: 90%;
  margin: auto;
}
.logo {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}
.logo img {
  width: 150px;
  /* height:50px;
      object-fit: cover; */
}
.logo h2 {
  font-size: 30px;
}
.wrapper {
  padding: 30px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255),
    rgba(234, 248, 255, 0.8)
  );
}
.wrapper-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.form-title h1 {
  font-weight: 700;
  font-size: 35px;
  font-family: "Quicksand", sans-serif;
}
.auxiliary {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.auxiliary .small-line {
  margin-right: 30px;
  width: 60px;
  height: 2px;
  background: rgb(0, 132, 255);
}
.auxiliary h3 {
  color: rgb(0, 132, 255);
  font-weight: bold;
  font-size: 13px;
  font-family: "Quicksand", sans-serif;
}
.account-btns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin-top: 30px;
  width: 90%;
}
.account-btns a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  font-family: "Quicksand", sans-serif;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  border: 1px solid rgba(220, 220, 220, 0.555);
  box-shadow: 0px 0px 3px 1px rgb(247, 247, 247);
}
.account-btns a img {
  margin-right: 10px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  -ms-border-radius: 15px;
  -o-border-radius: 15px;
}
.account-btns a p {
  font-size: 13px;
  color: #333;
  font-family: "Quicksand", sans-serif;
}
.form-container {
  margin-top: 30px;
  width: 90%;
}
.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin-bottom: 20px;
}
.form-row.login {
  display: block;
}
.form-container label {
  display: block;
  margin-bottom: 5px;
  font-family: "Quicksand", sans-serif;
}
.form-container .input-control {
  font-size: 15px;
  width: 100%;
  height: 45px;
  outline: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding-left: 5px;
  border: 1px solid gainsboro;
  box-shadow: 0px 0px 3px 1px rgb(247, 247, 247);
  font-weight: 500;
  font-family: "Quicksand", sans-serif;
}
::placeholder {
  font-size: 13px;
  font-family: "Quicksand", sans-serif;
}
.form-pass {
  margin-bottom: 20px;
}
.form-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.form-checkbox p {
  margin-left: 10px;
  font-family: "Quicksand", sans-serif;
}
.form-checkbox .agreement {
  cursor: pointer;
}
.form-submit {
  display: block;
}
.form-submit button {
  font-size: 15px;
  margin: 10px 0 20px;
  font-family: "Quicksand";
  width: 100%;
  height: 45px;
  font-weight: 600;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  border: none;
  color: white;
  box-shadow: 0px 0px 1px 1px rgb(0, 132, 255);
  background: rgb(0, 132, 255);
  cursor: pointer;
}
.addition p a {
  color: rgb(0, 132, 255);
  font-family: "Quicksand", sans-serif;
}
.svg-wrapper {
  margin-top: -80px;
}
@media (max-width: 965px) {
  .wrapper-content {
    grid-template-columns: repeat(1, 1fr);
  }
  .svg-wrapper {
    order: 1;
  }
  .form-wrapper {
    order: 2;
  }
  .form-container {
    margin-left: auto;
    margin-right: auto;
    width: 95%;
  }

  .addition {
    width: 97%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: repeat(1, 1fr);
  }
  .form-checkbox p {
    font-size: 13px;
  }
  .form-title h1 {
    font-size: 35px;
  }
  .wrapper {
    padding: 50px 0;
  }
  .form-container {
    margin-left: auto;
    margin-right: auto;
    width: 95%;
  }

  .addition {
    width: 97%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
}
@media (max-width: 320px) {
  .addition {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .account-btns {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
  }
  .form-container {
    margin-left: auto;
    margin-right: auto;
    width: 95%;
  }
}
</style>
